import { searchRequestData } from '../../Utility/apiHelper';
import * as actionType from './type';

export const handleRequestGetLead = (queryparams, updateStore = true) => async(dispatch) => {
    try {
            if(updateStore) {
                dispatch({
                    type: actionType?.REQUEST_GET_LEAD,
                    payload: true
                })
            }
            
            const leadSearchUrl = `${process.env.REACT_APP_BASE_URL}leads`;
            const responsedata = await searchRequestData(queryparams , leadSearchUrl , false)
            
            if(updateStore) {
                dispatch({
                    type: actionType.RECEIVED_GET_LEAD,
                    payload: responsedata?.data
                })
            }

            if(updateStore) {
                dispatch({
                    type: actionType?.REQUEST_GET_LEAD,
                    payload: false
                })
            }
            
            return responsedata?.data;
    } catch(error) {
        dispatch({
                type: actionType?.REQUEST_GET_LEAD,
                payload: false
            })

         return error?.response;
   
    }

   
}

export const handleRequestGetuser = (currentUser) => async(dispatch) => {
    try {
    
        const queryparam = {
              params: {
                clientId: currentUser?.client?.id,
               }
            }
            const clientSearchUrl = `${process.env.REACT_APP_BASE_URL}users`;
            const responsedata = await searchRequestData(queryparam,clientSearchUrl , false)
            dispatch({
                type: actionType.RECEIVED_GET_USER,
                payload : responsedata?.data
            })

            return responsedata?.data;
    } catch(error){
    
    }
    
}

export const handleRequestGetProduct = (queryparams) => async(dispatch) => {
    try {
            const productSearchUrl = `${process.env.REACT_APP_BASE_URL}products`;
            const responsedata = await searchRequestData(queryparams , productSearchUrl , false)
            dispatch({
                type: actionType.RECEIVED_GET_PRODUCT,
                payload: responsedata?.data
            })

            return responsedata?.data
                
            } catch(error) {
                
            }
}

export const handleRequestGetInvoice = (queryparams) => async(dispatch) => {
    try {
        
        const invoiceSearchUrl = `${process.env.REACT_APP_BASE_URL}invoice`;
        const response = await searchRequestData(queryparams , invoiceSearchUrl , false)
        dispatch({
            type : actionType?.RECEIVED_GET_INVOICE,
            payload : response?.data
        })

        return response?.data
           
    }
    catch(error){
    
    }
}

export const handleRequestGetOrder = (queryparams, updateStore = true) => async(dispatch) => {
    try {
            if(updateStore) {
                dispatch({
                    type: actionType.REQUEST_GET_ORDER,
                    payload: true
                })
            }
           
            const orderSearchUrl = `${process.env.REACT_APP_BASE_URL}sales-orders`;
            const responsedata = await searchRequestData(queryparams , orderSearchUrl , false)
            dispatch({
                type: actionType.RECEIVED_GET_ORDER,
                payload: responsedata?.data
            })

            if(updateStore) {
                dispatch({
                    type: actionType.REQUEST_GET_ORDER,
                    payload: false
                })
            }

            return responsedata?.data;

    }
    catch(error){
        if(updateStore) {
                dispatch({
                    type: actionType.REQUEST_GET_ORDER,
                    payload: false
                })
            }
    }
}